// extracted by mini-css-extract-plugin
export default {"note-helper":"AddAPackageForm_note-helper__dtiQT","char-count":"AddAPackageForm_char-count__GG7H4","error":"AddAPackageForm_error__HL-M5"};